import { useAuth } from "../auth.js";
import { Brand } from "../Brand.js";

export function AuthUnavailable({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) {
  const { continueToSignIn } = useAuth();

  return (
    <div className="signin">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onRetry();
        }}
      >
        <Brand title="Wirral Music Factory" subtitle="Hub" className="brand-auth" />
        <div className="notice small" role="status">
          {message}
        </div>
        <button type="submit">Try again</button>
        <button type="button" className="quiet small" onClick={continueToSignIn}>
          Sign in instead
        </button>
      </form>
    </div>
  );
}
